// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DHf_H","col":"styles_col__fmynM"};